import products from "../data/products.json";
import ProductCard from "../components/ProductCard";
import ContactForm from "../components/ContactForm";

export default function Fabrication() {
  return (
    <div className="p-6 max-w-6xl mx-auto">

      <h1 className="text-4xl font-bold mb-4">Fabrication Services</h1>
<p className="text-gray-600 mb-6">
  Our fabrication services bridge the gap between design and production. We specialize
  in precision cutting, engraving, and 3D printing using wood and acrylic materials,
  delivering high-quality customized products for individuals and organizations.
</p>

<h2 className="text-2xl font-semibold mb-4">Capabilities</h2>

<ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
  <li>Laser cutting and engraving (wood & acrylic)</li>
  <li>Custom signage and decorative products</li>
  <li>Batch production for organizations</li>
  <li>Direct shipping to customer locations</li>
</ul>

<h2 className="text-2xl font-semibold mb-4">Fulfillment Model</h2>

<div className="grid md:grid-cols-3 gap-4 mb-8">

  <div className="p-4 bg-white shadow rounded">
    <h3 className="font-semibold">Design Intake</h3>
    <p className="text-sm text-gray-600">Upload or request custom designs</p>
  </div>

  <div className="p-4 bg-white shadow rounded">
    <h3 className="font-semibold">Production</h3>
    <p className="text-sm text-gray-600">Precision cutting and fabrication</p>
  </div>

  <div className="p-4 bg-white shadow rounded">
    <h3 className="font-semibold">Delivery</h3>
    <p className="text-sm text-gray-600">Direct shipping to stores or customers</p>
  </div>

</div>
<h2 className="text-2xl font-semibold mb-4">Use Cases</h2>

<ul className="list-disc pl-6 text-gray-600 mb-8 space-y-2">
  <li>Corporate signage and branding materials</li>
  <li>Customized gifting solutions</li>
  <li>Retail display products</li>
  <li>Educational and student prototypes</li>
</ul>

      {/* Products */}
      <h2 className="text-2xl font-semibold mb-4">Our Products</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {products.map((p) => (
          <ProductCard key={p.id} product={p} />
        ))}
      </div>

      {/* Custom Order */}
      <div className="mt-12 bg-gray-100 p-6 rounded">
        <h2 className="text-2xl font-semibold mb-2">Custom Fabrication</h2>
        <p className="text-gray-600 mb-4">
          Have a custom design? Upload your file and we’ll manufacture it.
        </p>

        <ContactForm />
      </div>

    </div>
  );
}
